import React, { useEffect } from 'react';

const Dashboard = () => {
  useEffect(() => {
    // navigate(MAIN_STORE_ROUTE_KEYS.INVENTORY_STOCK, { replace: true });
  }, []);
  return <div />;
};

export default Dashboard;
